import { connect } from 'react-redux';
import { Button, IconName, Stack } from '@optimus-web/core';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { openBillingAccount, openPayments } from '../../actions';

const ActionsButtons = ({ openItemCount, openBillingScreen, openPaymentsScreen }: $TSFixMe) => (
    <Stack itemAlignment="center" alignment="end" spacing="100">
        <Button
            variant={openItemCount > 0 ? 'primary' : undefined}
            icon={IconName.PaymentReport}
            onClick={openBillingScreen}
            type="submit"
        >
            <LocalizedText textKey={TextKey.Billing} />
        </Button>
        <Button icon={IconName.PaymentCard} onClick={openPaymentsScreen} type="submit">
            <LocalizedText textKey={TextKey.PaymentPlural} />
        </Button>
    </Stack>
);
// @ts-expect-error $TSFixMeError: Property 'accountId' does not exist on type '{}'.
export default connect(null, (dispatch, { accountId }) => ({
    // @ts-expect-error $TSFixMeError: Argument of type '(dispatch: $TSFixMe, getState: $TSFixMe) => any' is not assignable to parameter of type 'Action<any>'.
    openBillingScreen: () => dispatch(openBillingAccount({ accountId })),
    // @ts-expect-error $TSFixMeError: Argument of type '(dispatch: $TSFixMe, getState: $TSFixMe, { resolveRoute }: $TSFixMe) => any' is not assignable to para...
    openPaymentsScreen: () => dispatch(openPayments({ accountId })),
}))(ActionsButtons);
